module.exports = __webpack_public_path__ + "static/media/合作案例_02.a64202c1.jpg";